/** Shared Modus form field visuals (TextField / TextArea). */

/** Enabled field outline */
export const MODUS_FIELD_BORDER_ENABLED = "#171C1E";

/** Disabled / read-only fill — matches TextArea + TextField */
export const MODUS_FIELD_BG_DISABLED = "#F2F4F7";

/** Disabled text */
export const MODUS_FIELD_TEXT_DISABLED = "#9CA3AF";

export const MODUS_FIELD_BORDER_ERROR = "#AB1F26";
